app.controller('propertySearchController', function ($scope, $rootScope, $location, safeApply, searchService, systemService) {

  $scope.propertyAddress = ''
  $scope.signupFocused = false
  $scope.showSignup = true

  $scope.inputFocused = function () {
    $scope.signupFocused = true
    $scope.showSignup = false
    window.scrollTo({ top: 0, behavior: 'smooth' })
    safeApply($scope)
  }

  init()

  // try {
  //   Intercom('boot', {
  //     app_id: "qme4eg2m",
  //     hide_default_launcher: false,
  //     alignment: 'right',
  //     custom_launcher_selector: '.open_intercom',
  //     horizontal_padding: 2,
  //     vertical_padding: 2
  //   })
  //   try {
  //     Intercom("update")
  //   } catch (error) { console.log(error); }
  // } catch (error) { console.log(error); }

  // Advanced Search ---------------------------------------------------------------

  // By Tax ID -------------------------
  $scope.queryTaxid = async function (searchText) {
    let obj = {
      cad_code: $scope.searchObj.county.cad_code,
      prop_uid: `${$scope.searchObj.county.cad_code}${searchText}`
    }
    let getTaxIdResults = await searchService.getTaxIDs(obj)
    console.log('getTaxIdResults :>> ', getTaxIdResults);
    return getTaxIdResults.data.data.map(function (item) {
      return {
        display: item.full_address,
        value: item.full_address.toLowerCase(),
        entryID: item.id,
        prop_uid: item.prop_uid,
        address: item.usps_full_address,
        account: item.account,
        owner: item.owner_name,
        division: item.division,
        cad_code: item.cad_code,
        fullData: item
      }
    })
  }

  $scope.onTaxidSelect = (item) => {
    if (!item) return false
    try {
      $scope.searchObj.properties[0] = item
      $scope.searchObj.property_found = true
      console.log('$scope.searchObj. :>> ', $scope.searchObj);
    } catch (error) { console.log('error :>> ', error); }
  }
  // END: By Tax ID --------------------


  // By Address --------------
  $scope.queryStreets = async function (searchText) {
    let obj = {
      cad_code: $scope.searchObj.county.cad_code,
      situs: { num: $scope.searchObj.address.number, street: searchText }
    }
    let getStreetsResults = await searchService.getStreets(obj)
    return getStreetsResults.data.data.map(function (item) {
      return {
        display: item.full_address,
        value: item.full_address.toLowerCase(),
        entryID: item.id,
        prop_uid: item.prop_uid,
        address: item.usps_full_address,
        account: item.account,
        owner: item.owner_name,
        division: item.division,
        cad_code: item.cad_code,
        fullData: item
      }
    })
  }

  $scope.onStreetSelect = (item) => {
    console.log("onStreetSelect", item);
    try {
      $scope.searchObj.properties[0] = item
      $scope.searchObj.property_found = true
    } catch (error) {
      console.log('error :>> ', error);
    }
  }

  $scope.countyAndStreetSelected = () => {
    return !($scope.searchObj.county.cad_code != "" && $scope.searchObj.address.number.length > 0)
  }

  // END:  Advanced Search ---------------------------------------------------------------

  $scope.initGoogleSearch = () => {
    setTimeout(function () {
      try {
        autocomplete = new google.maps.places.Autocomplete(
          (document.getElementById('autocomplete')), { types: ['address'], componentRestrictions: { country: "us" } }
        )
        autocomplete.addListener('place_changed', function () {
          $scope.subAddressSearch('addSearch_google')
        })
      } catch (error) { }
    }, 0)
    $("body").trigger("resize")
  }

  $scope.propertySelected = async () => {
    $scope.regAnalysis = { analysis_running: true }
    const p = $scope.searchObj.properties
    console.log('p :>> ', p);
    let search_method = searchService.getSearchMethod()

    switch (search_method) {
      case 1: // Base Search - Show Analysis
        systemService.route_change('analysis', { uid: p.uid })
        break
      case 2: // File a Protest Search - Take to Registration
        systemService.route_change('registration', { cad_code: p.cad_code, account: p.account })
        break
    }
    safeApply($scope)

    return


    let obj = {
      cad_account: p.account,
      cad_code: p.cad_code,
      detail: 'registration'
    }
    console.log('obj :>> ', obj);
    let performAnalysisResults = await searchService.performAnalysis(obj)
    console.log('performAnalysisResults :>> ', performAnalysisResults);
    $scope.regAnalysis.analysis_running = false
    if (performAnalysisResults.data.success == true) {
      $scope.regAnalysis = { ...$scope.regAnalysis, ...performAnalysisResults.data.data }
      $scope.regAnalysis.full_address = p.full_address
      $scope.regAnalysis.cad_account = p.account
      $scope.regAnalysis.cad_code = p.cad_code
      // if (performAnalysisResults.data.data.smartcomp_id < 1) {
      //   $scope.regAnalysis.edge_message = performAnalysisResults.data.data.edge_message
      // }

    } else {
      $scope.regAnalysis = {
        money_back_guarantee: false,
        smartcomp_id: -9999,
        edge_message: "The system was unable to run a PRE-ANALYSIS on this property, Please chat in with us for more information!"
      }
    }
    safeApply($scope)
  }

  $scope.countyChange = (obj) => {
    $scope.searchObj.county.name = obj.name
    $scope.searchObj.county.cad_code = obj.cad_code
  }

  let additionalInfoModalEl = document.querySelector('#additionalInfo')
  let additionalInfoModal = bootstrap.Modal.getOrCreateInstance(additionalInfoModalEl)

  $scope.subAddressSearch = async function (type) {
    console.log("****************************************************");
    var place = autocomplete.getPlace() || undefined
    if (place.formatted_address === undefined) {
      $scope.resetSearch()
      return
    }
    let googleSearchObj = searchService.convertGoogleResponseToObject(place)
    let searchObj = angular.copy(googleSearchObj)

    // console.log('googleSearchObj :>> ', JSON.stringify(googleSearchObj, null, 2));
    // console.log("**************************************");
    // return

    let county_list = searchService.getCountyList()

    $scope.searchObj.error_message_id = 0
    $scope.searchObj.error_message = []
    $scope.searchObj.show_button_try_again = false
    $scope.searchObj.show_button_chat = false
    $scope.searchObj.property_found = false

    if (searchObj.state.short_name != 'TX') {
      $scope.searchObj.error_message_id = 1
      $scope.searchObj.error_message = []
      $scope.searchObj.property_found = true
      $scope.searchObj.show_button_try_again = true
      safeApply($scope)
      return
    }
    if (searchObj.cad_code == '000') {
      $scope.searchObj.error_message_id = 2
      $scope.searchObj.error_message = `This property is located in ${searchObj.county_name} County.`
      $scope.searchObj.property_found = true
      $scope.searchObj.show_button_try_again = true
      safeApply($scope)
      return
    }

    try {
      let results, getPropUIDResults

      // check if searchObj.cad_code is in $rootScope.cadCodes
      if ($rootScope.cadCodes.split(',').map(cadcode => cadcode.trim()).indexOf(searchObj.cad_code) > -1) {
        console.log("FOUND TO BE A NEW COUNTY");
        console.log('searchObj :>> ', searchObj);
        getPropUIDResults = {
          success: true,
          data: {
            analysis: false,
            manual: true,
            situs_num: searchObj.street_number.short_name,
            situs_street: searchObj.street_name.short_name,
            situs_city: searchObj.city.short_name,
            situs_zip: searchObj.zip.short_name,
            county: searchObj.county_name,
            _header_message: ''
          }
        }
      } else {
        // Build the search object for the SQL search using LEVENSHTEIN search
        const searchLevenshteinObj = {
          situs_num: googleSearchObj.street_number.short_name,
          situs_street: googleSearchObj.street_name.short_name,
          situs_city: googleSearchObj.city.short_name,
          full_address: googleSearchObj.formatted_address,
          cad_code: searchObj.cad_code
        }
        getPropUIDResults = await searchService.searchLevenshtein(searchLevenshteinObj)
        getPropUIDResults = getPropUIDResults.data
      }
      results = getPropUIDResults.data

      // Got valid results
      console.log('getPropUIDResults :>> ', getPropUIDResults);
      if (getPropUIDResults.success && getPropUIDResults.data) {
        console.log("passed if");
        // Testing ONLY --------------
        // results.analysis = false
        // results.manual == true
        // ---------------------------

        // All good, we have a single property and can run an analysis
        if (results.analysis == true) {
          $scope.searchObj.properties = results
          $scope.searchObj.property_found = true
          $scope.searchObj.properties = results
          safeApply($scope)
          return
        }

        // Cannot run an analysis on this property
        // But we want to capture user info and send an email to Intercom
        if (results.analysis == false && results.manual == true) {
          $scope.searchObj.properties = results
          $scope.searchObj.property_found = true
          $scope.additionalInfo = {
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            appraisal_district: results.county,
            appraisal_account: '',
            street_address: `${results.situs_num} ${results.situs_street}`,
            unit_number: '',
            city: `${results.situs_city}`,
            zip_code: `${results.situs_zip}`,
            owner_name: '',
            property_type: '',
            additional_info: '',
            _header_message: results.describe,
          }
          additionalInfoModal.show()
          safeApply($scope)
          return
        }

        // Cannot run an analysis on this property
        // And we do NOT want to capture user info, just show a message
        if (results.analysis == false && results.manual == false) {
          $scope.searchObj.property_found = true
          safeApply($scope)
          return
        }
      } else {
        $scope.searchObj.error_message_id = 4
        $scope.searchObj.error_message = [`Sorry, we were unable to find the property in our database. Please try again or chat with us for more information.`]
        $scope.searchObj.show_button_try_again = true
        $scope.searchObj.show_button_chat = true
        $scope.searchObj.properties = []
        $scope.searchObj.property_found = false
      }
    } catch (error) {
      $scope.searchObj.properties = []
      $scope.searchObj.property_found = true
      safeApply($scope)
      return
    }
  }
  $scope.additionalInfoSubmit = async () => {
    const addition_info_email_obj = {
      first_name: $scope.additionalInfo.first_name,
      last_name: $scope.additionalInfo.last_name,
      email: $scope.additionalInfo.email,
      phone: $scope.additionalInfo.phone,
      appraisal_district: $scope.additionalInfo.appraisal_district,
      appraisal_account: $scope.additionalInfo.appraisal_account,
      street_address: $scope.additionalInfo.street_address,
      unit_number: $scope.additionalInfo.unit_number,
      city: $scope.additionalInfo.city,
      zip_code: $scope.additionalInfo.zip_code,
      owner_name: $scope.additionalInfo.owner_name,
      property_type: $scope.additionalInfo.property_type,
      additional_info: $scope.additionalInfo.additional_info
    }
    let email_additional_info_results = await systemService.functionCall({ type: 'sendEmail', data: addition_info_email_obj })
    toastr.success('Thank you for your information. We will be in touch shortly.', 'Information Submitted', { timeOut: 15000 })
    $scope.searchObj.error_message_id = 0
    $scope.searchObj.error_message = []
    $scope.searchObj.show_button_try_again = false
    $scope.searchObj.show_button_chat = false
    additionalInfoModal.hide()
    $scope.searchObj.property_found = false
    $scope.propertyAddress = ''
    safeApply($scope)
  }
  $scope.additionalInfoCancel = () => {
    $scope.searchObj.error_message_id = 0
    $scope.searchObj.error_message = []
    $scope.searchObj.show_button_try_again = false
    $scope.searchObj.show_button_chat = false
    $scope.searchObj.property_found = false
    $scope.propertyAddress = ''
    additionalInfoModal.hide()
  }

  $scope.cancelAdvancedSearch = () => {
    $scope.propertyAddress = ''
    $rootScope.advancedSearch = false
  }

  $scope.openChat = (message_id) => {
    let message = ''
    switch (message_id) {
      case 3:
        message = `My property is not a Condo or Multi-Tenant property.`
        break
    }
    Intercom('showNewMessage', message)
    safeApply($scope)
  }

  async function init() {
    resetSearchObj()
    let countyListResults = await systemService.functionCall({ type: "countyList", active_only: true })
    if (countyListResults.data.success && countyListResults.data.data.length > 0) {
      $scope.counties = countyListResults.data.data
    } else {
      console.log("System Error")
    }
    safeApply($scope)
  }

  function resetSearchObj() {
    $scope.searchObj = {
      google_search: null,
      county: { name: "Select County", cad_code: "" },
      address: { number: "", street: "" },
      properties: [{
        prop_uid: "",
        full_address: "",
        owner_name: "",
        division: "",
        account: ""
      }],
      property_found: false
    }
    $rootScope.advancedSearch = false
    safeApply($scope)
  }

  $scope.resetSearch = function () {
    console.log("resetSearch");
    $scope.regAnalysis = { analysis_running: false }
    angular.element(document.querySelector("#autocomplete")).val("")
    angular.element(document.querySelector("#autocomplete")).blur()
    $scope.streetSearchText = ""
    $scope.taxidSearchText = ""
    $scope.propertyAddress = null
    $rootScope.advancedSearch = false
    setTimeout(function () {
      angular.element(document.querySelector("#autocomplete")).focus()
    }, 0)
    resetSearchObj()
  }


})